module.exports = __webpack_public_path__ + "media/images/Share2-blue-7d4a79e34fa595417e0dc576d1a98cf0.svg";